import './App.css';
import DealList from './components/DealList.js';
import FeaturedCarousel from './components/FeaturedCarousel.js';
import DealOfTheDay from './components/DealOfTheDay.js';
import TopCategoriesSidebar from './components/TopCategoriesSidebar.js';
import Header from './components/Header'
import ScrollToTopButton from './components/ScrollToTopButton.js'
import * as React from 'react';
import axios from 'axios';
import queryString from "query-string";
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import GridViewIcon from '@mui/icons-material/GridView';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from "@mui/material/ListItemIcon";
import Slide from "@mui/material/Slide";
import Button from '@mui/material/Button';
import ReactGA from 'react-ga4';
import useAnalyticsEventTracker from './components/useAnalyticsEventTracker';
import { RotatingLines } from 'react-loader-spinner'
import { debounce } from 'lodash';
import { useAddToHomescreenPrompt } from "./functions/AddToHomeScreen.js";
import { isAndroid, isIOS, isChrome, isSafari, isFirefox,isMobile} from 'react-device-detect';
import { useTranslation } from "react-i18next";
import { sendData } from './functions/Utils.js'   


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const RefreshTimerTime = 45;
const IMAGE_PRELOAD_TIMEOUT_MS = 5000;

function preloadImages(urls, timeoutMs = IMAGE_PRELOAD_TIMEOUT_MS) {
  const list = [...new Set(urls.filter(Boolean))];
  if (list.length === 0) return Promise.resolve();

  const loadOne = (src) => new Promise((resolve) => {
    const img = new Image();
    const done = () => resolve();
    img.onload = () => {
      if (typeof img.decode === 'function') img.decode().then(done, done);
      else done();
    };
    img.onerror = done;
    img.src = src;
  });

  const everything = Promise.all(list.map(loadOne));
  const safetyTimeout = new Promise((resolve) => setTimeout(resolve, timeoutMs));
  return Promise.race([everything, safetyTimeout]);
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
      width: 250
    },
  },
  style: {
    position: 'absolute',
  },
  disableScrollLock: true
};

function App() {

  const { t, i18n } = useTranslation();
  const [deals, setDeals] = React.useState([]);
  const [tempDeals, setTempDeals] = React.useState([]);

  //
  const [search, setSearch] = React.useState((sessionStorage.getItem('dealId') && sessionStorage.getItem('search')) ? sessionStorage.getItem('search') : getHashSearch());
  const [sort, setSort] = React.useState((sessionStorage.getItem('dealId') && sessionStorage.getItem('sort')) ? sessionStorage.getItem('sort') : 3);
  const [selected, setSelected] = React.useState((sessionStorage.getItem('dealId') && sessionStorage.getItem('selected')) ? JSON.parse(sessionStorage.getItem('selected')) : []);


  const [openSort, setOpenSort] = React.useState(false);
  const [openCategorie, setOpenCategorie] = React.useState(false);
  // Drives the staggered "deal the cards" morph on Select All / Deselect All.
  const [bulkAnim, setBulkAnim] = React.useState(false);
  const bulkAnimTimer = React.useRef(null);

  const [hasMore, setHasMore] = React.useState(false);
  const [noResult, setNoResult] = React.useState(false);
  const [categories, setCategories] = React.useState([]);

  const [initialLoadShow, setInitialLoadShow] = React.useState(false);
  const [inListLoadShow, setInListLoadShow] = React.useState(!sessionStorage.getItem('dealId'));
  const [swapping, setSwapping] = React.useState(false);

  const POSTS_ENDPOINT = process.env.REACT_APP_API_URL + "/Deals";
  const DEAL_OF_THE_DAY_ENDPOINT = process.env.REACT_APP_API_URL + "/Deals/OfTheDay";

  const isAllSelected = categories.length > 0 && selected.length === categories.length;
  const gaEventTracker = useAnalyticsEventTracker('Header');
  const isFacebookInAppBrowser = navigator.userAgent.match(/FBAN|FBAV|FB_IAB/i);

  const isRefScroller = React.useRef(null);

  //install to home screen
  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  const [isAppInstalled, setIsAppInstalled] = React.useState(false);
  const [isVisible, setVisibleState] = React.useState(false);

  const [timer, setTimer] = React.useState(true);
  const [timerId, setTimerId] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [refreshKey, setRefreshKey] = React.useState(0);
  const fetchSeqRef = React.useRef(0);
  // The "Top deal of the day" — the active/alive/public deal whose product
  // earned the most affiliate commission today, picked server-side. Fetched
  // here so it can be passed to <DealOfTheDay> AND so its id can be excluded
  // from the carousel (avoids showing it twice).
  const [topDeal, setTopDeal] = React.useState(null);
  

  React.useEffect(() => {
    isPWAInstalled();
    getLanguage();
    document.addEventListener("touchmove", function (e) {
      document.getElementById("bar-search-field").blur();
    });
  }, []);

  const refreshPage = () =>  {
    if (window.scrollY <= 0) {
      fetchSeqRef.current++;
      setNoResult(false);
      setDeals([]);
      if (isRefScroller.current) {
        isRefScroller.current.pageLoaded = 0;
      }
      setHasMore(true);
      setTimer(false);
      setRefreshKey(k => k + 1);
    }
  }

  React.useEffect( () => {
    if (timer) {
  
       // timer should start
       if (window.scrollY <= 0) {
        let id = setTimeout( () => { refreshPage();} , (RefreshTimerTime * 1000));
        setTimerId(id);
      }
    } else if (!timer && timerId) {
       // timer is started but is interrupted by user
       clearTimeout(timerId);
       setTimer(true);
    }
    return () => {
       // clean up
       if (timerId) {
           clearTimeout(timerId);
       }
    }
  }, [timer]); // listen to changes on timer state

  const isPWAInstalled = async () => {
    if ("getInstalledRelatedApps" in window.navigator) {
      const relatedApps = await navigator.getInstalledRelatedApps();
      let installed = false;
      relatedApps.forEach((app) => {
        //if your PWA exists in the array it is installed
        if (app.url === (process.env.REACT_APP_MAIN_URL + "/" + process.env.REACT_APP_MANIFEST_NAME)) {
          installed = true;
        }
      });
      setIsAppInstalled(installed);

      if(!installed)
      {
        if (!sessionStorage.getItem('prompt')){
          setVisibleState(true);
          sessionStorage.setItem('prompt', true);
        }
      }

      if (!sessionStorage.alreadyLogged) {
        sendData(installed ,'IsInstalled');
        sessionStorage.alreadyLogged = 1;
      }      
    }
  };

  if (process.env.NODE_ENV === "production") {
    const TRACKING_ID = "G-C1893R248H";
    ReactGA.initialize(TRACKING_ID);
  }

  function getLanguage()
  {

    if(isMobile)
    {
      if (localStorage.getItem('language'))
      {
        return;
      }
      
      var url = queryString.stringifyUrl({
        url: process.env.REACT_APP_API_URL + "/Language"
      });

      axios.get(url, {
        validateStatus: function (status) {
          return status < 500; // Resolve only if the status code is less than 500
        }
      })
      .then(res => {
        if (res.status < 400) {
          localStorage.setItem('language', res.data);
          
          if(i18n.resolvedLanguage !== res.data)
          {
            i18n.changeLanguage(res.data);
          }
        }
        else {
          return '';
        }
      })
    }
  }

  function getDeals(page) {
    setIsLoading(true);
    const mySeq = fetchSeqRef.current;

    var find = ',';
    var re = new RegExp(find, 'g');
    var str = selected.toString().replace(re, '|');

    var url = queryString.stringifyUrl({
      url: POSTS_ENDPOINT,
      query: {
        page,
        limit: 20,
        search: search,
        categories: str,
        sortType: sort
      }
    });

    const appendUnique = (existing, incoming) => {
      const ids = new Set(existing.map(d => d.id));
      return [...existing, ...incoming.filter(d => !ids.has(d.id))];
    };

    axios.get(url, {
      validateStatus: function (status) {
        return status < 500; // Resolve only if the status code is less than 500
      }
    })
      .then(res => {
        if (mySeq !== fetchSeqRef.current) {
          setIsLoading(false);
          return;
        }
        if (res.status < 400) {

          setNoResult(false);
          gaEventTracker('pageLoad', '', page);


          if (sessionStorage.getItem('page')) {
            if (sessionStorage.getItem('page') > page && sessionStorage.getItem('dealId')) {
              if (page === 1)
                setInitialLoadShow(true);

              setTempDeals(tempDeals => appendUnique(tempDeals, res.data));
            }
            else {
              setInListLoadShow(true);
              if (isFacebookInAppBrowser)
                sessionStorage.setItem('page', page);
              if (sessionStorage.getItem('dealId')) {
                setDeals(appendUnique(tempDeals, res.data));
                setTempDeals([]);
              }
              else {
                setDeals(deals => appendUnique(deals, res.data));
                setInitialLoadShow(false);

              }
            }
          }
          else {
            setDeals(deals => appendUnique(deals, res.data));
            if (isFacebookInAppBrowser)
              sessionStorage.setItem('page', page);
          }
          setIsLoading(false);
        }
        else {
          setNoResult(true);
          setHasMore(false);
          gaEventTracker('pageLoadEnd', '', page);
          setIsLoading(false);
        }
      })


  }

  const reloadFirstPage = (overrides = {}) => {
    const nextSort = overrides.sort != null ? overrides.sort : sort;
    const nextSearch = overrides.search != null ? overrides.search : search;
    const nextSelected = overrides.selected != null ? overrides.selected : selected;

    fetchSeqRef.current++;
    const mySeq = fetchSeqRef.current;
    setIsLoading(true);
    setSwapping(true);
    setNoResult(false);
    setHasMore(true);

    const str = (nextSelected || []).join('|');
    const url = queryString.stringifyUrl({
      url: POSTS_ENDPOINT,
      query: { page: 1, limit: 20, search: nextSearch, categories: str, sortType: nextSort }
    });

    axios.get(url, { validateStatus: (status) => status < 500 })
      .then(async res => {
        // A newer switch superseded this one — it now owns the spinner and will
        // clear it. Bail without touching shared loading state.
        if (mySeq !== fetchSeqRef.current) return;
        if (res.status < 400) {
          const data = Array.isArray(res.data) ? res.data : [];
          // Wait for every image to download + decode before revealing, so the
          // whole page appears imaged at once (the spinner stays up meanwhile).
          await preloadImages(data.map(d => d.imageUrl || '/EmptyImage.jpg'));
          // Re-check: the user may have switched again during the preload.
          if (mySeq !== fetchSeqRef.current) return;
          setNoResult(false);
          setDeals(data);
          // The list didn't remount, so realign InfiniteScroll's internal page
          // counter to "page 1 loaded" — the next scroll continues at page 2.
          if (isRefScroller.current) isRefScroller.current.pageLoaded = 1;
          if (isFacebookInAppBrowser) sessionStorage.setItem('page', 1);
          setSwapping(false);
          setIsLoading(false);
        }
        else {
          setDeals([]);
          setNoResult(true);
          setHasMore(false);
          setSwapping(false);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (mySeq !== fetchSeqRef.current) return;
        setSwapping(false);
        setIsLoading(false);
      });
  }


  function getHashSearch() {
    if (window.location.hash == 0)
      return '';

    let splitted = window.location.hash.substring(1).split('|');
    if (splitted.length === 0)
      return '';
    let searchhash = splitted.filter(x => x.startsWith('search='))[0];

    if (searchhash && searchhash.length > 7) {
      window.location.hash = '';
      let searchValue = searchhash.substring(7).replaceAll('+', ' ');
      return decodeURIComponent(searchValue);
    }

    return '';
  }

  React.useEffect(() => {
    if (isFacebookInAppBrowser) {
      if (sessionStorage.getItem('dealId')) {
        const element = document.getElementById('dealId' + sessionStorage.getItem('dealId'));
        if (element) {
          element.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
          });

          setInListLoadShow(true);
          setTimeout(() => hackFacebook(), 50);

          sessionStorage.removeItem("dealId");
          sessionStorage.removeItem('selected');
          sessionStorage.removeItem('sort');
          sessionStorage.removeItem('search');
        }
        const bar = document.getElementById('bar-search-field');
        if (bar)
          bar.value = search;
        setInitialLoadShow(false);
      }
    }
  }, [deals])

  let touchstartY = 0;
  let touchstartX = 0;
  let gestureDirection = null;
  let touchStart = false;
  const DIRECTION_COMMIT_PX = 8;
  const REFRESH_TRIGGER_PX = 40;

  React.useEffect(() => {
    document.title = 'DEALS EMPIRE';
    const CATEGORIES_ENDPOINT = process.env.REACT_APP_API_URL + "/Categories";

    function getCategories() {
      var url = queryString.stringifyUrl({
        url: CATEGORIES_ENDPOINT
      });

      axios.get(url)
        .then(res => {
          setCategories(res.data);
          setDeals([]);
          setHasMore(true);
          if (!sessionStorage.getItem('selected')) {
            setSelected(res.data.map(x => x.id));
          }

        })
    }

    getCategories();

    document.querySelectorAll('[type=search]').forEach((element) => {
      hideMobileKeyboardOnReturn(element);
    });

    let bar = document.getElementById('bar-search-field');
    if (bar)
      bar.value = search;

      setTimeout(() => {
        setVisibleState(false);
      }, 30000);


      document.addEventListener('touchstart', e => {
        if (window.location.hash == 0) {
          touchstartY = e.touches[0].clientY;
          touchstartX = e.touches[0].clientX;
          gestureDirection = null;
          touchStart = false;
        }
      });
      document.addEventListener('touchmove', e => {
        if (window.location.hash == 0){
          const touchY = e.touches[0].clientY;
          const touchX = e.touches[0].clientX;
          const touchDiffY = touchY - touchstartY;
          const touchDiffX = touchX - touchstartX;

          if (gestureDirection === null) {
            const absY = Math.abs(touchDiffY);
            const absX = Math.abs(touchDiffX);
            if (absY > DIRECTION_COMMIT_PX || absX > DIRECTION_COMMIT_PX) {
              gestureDirection = absY > absX ? 'vertical' : 'horizontal';
            }
          }

          if (gestureDirection === 'vertical' && touchDiffY > 0 && window.scrollY === 0) {
            let element = document.getElementById('refreshIconTop');
            var top = ((touchDiffY/2)-50) > 75 ? 75 : ((touchDiffY/2)-50) ;
            element.style.top = top + "px";
            element.classList.add("visible");

            touchStart = touchDiffY > REFRESH_TRIGGER_PX;
            e.preventDefault();
          }
        }
      });
      document.addEventListener('touchend', e => {
        if (window.location.hash == 0){
          if (touchStart) {
            touchStart = false;
            let element = document.getElementById('refreshIconTop');
            element.classList.remove("visible");
            element.style.top = "-50px";
            refreshPage();
          } else if (gestureDirection === 'vertical') {
            let element = document.getElementById('refreshIconTop');
            if (element) {
              element.classList.remove("visible");
              element.style.top = "-50px";
            }
          }
        }
      });
    
  }, []);

  function hackFacebook() {
    if (window.scrollY > 125) {
      if (!sessionStorage.getItem('scrollDirectionUp')) {
        document.getElementById('scroll-to-top').style.bottom = "67px";
      }
      else
        document.getElementById('scroll-to-top').style.bottom = "23px";
    }
    sessionStorage.setItem('scrollDirectionUp', true);
  }

  const launchSearch = (e) => {
    fetchSeqRef.current++;
    if (isRefScroller.current) {
      isRefScroller.current.pageLoaded = 0;
    }
    setHasMore(true);
    setSearch(e.target.value);
    setDeals([]);
    gaEventTracker('search', e.target.value);
    setTimer(false);
  }

  const handleChange = (event) => {
    const nextSort = event.target.value;
    setSort(nextSort);
    gaEventTracker('order', '', nextSort);
    setTimer(false);
    reloadFirstPage({ sort: nextSort });
  };

  const hideMobileKeyboardOnReturn = (element) => {
    element.addEventListener('keyup', (keyboardEvent) => {
      const key = keyboardEvent.code || keyboardEvent.keyCode;
      if (key === 'Enter' || key === 13) {
        element.blur();
      }
    });
  };

  const deboucedOnChange = debounce(launchSearch, 500);

  const handleClearSearch = () => {
    const bar = document.getElementById('bar-search-field');
    if (bar) bar.value = '';
    deboucedOnChange.cancel();
    launchSearch({ target: { value: '' } });
  };

  // Sidebar (desktop) — click a single category to filter the deal list
  // to just that one. Mirrors the bookkeeping the categories Select does
  // on change (reset deals, bump fetch seq, restart auto-refresh timer).
  const handleSidebarCategorySelect = (catId) => {
    fetchSeqRef.current++;
    setNoResult(false);
    setDeals([]);
    setHasMore(true);
    setSelected([catId]);
    gaEventTracker('categories', String(catId));
    setTimer(false);
  };

  // Carousel + Deal of the day share the same visibility conditions — they
  // both are "discovery"-style elements that don't fit a narrowed search
  // or non-default sort context. Computed once and passed to both.
  const heroHidden = (search && search.length > 0) || initialLoadShow || sort !== 3;

  // Featured-stack visibility: true iff the Deal of the day banner would
  // render. Drives both the `is-no-featured` grid-collapse class and
  // whether the wrapper itself mounts.
  const anyFeaturedShowing = !heroHidden && !!topDeal;

  // Fetch the "Top deal of the day" for the DealOfTheDay banner: the
  // active/alive/public deal whose product earned the most affiliate
  // commission today, chosen server-side (GET /Deals/OfTheDay). It is a
  // global pick (not category-scoped); a 404 means no qualifying deal yet
  // today and the banner stays hidden. Only runs when the hero is visible.
  React.useEffect(() => {
    if (heroHidden) { setTopDeal(null); return; }
    let stale = false;
    axios.get(DEAL_OF_THE_DAY_ENDPOINT, { validateStatus: (s) => s < 500 })
      .then((res) => {
        if (stale) return;
        const deal = res.status >= 200 && res.status < 300 && res.data && !Array.isArray(res.data)
          ? res.data
          : null;
        setTopDeal(deal);
      })
      .catch(() => { if (!stale) setTopDeal(null); });
    return () => { stale = true; };
  }, [heroHidden, refreshKey, DEAL_OF_THE_DAY_ENDPOINT]);


  return (
    <div className="App">

      <Header />

      <IconButton type="button" sx={{ p: '10px' }} aria-label="search" id="refreshIconTop">
        <RefreshIcon />
      </IconButton>
      {/* On desktop the filter bar is a grid item inside `.desktop-layout`
          so its width matches the main column (not the full container).
          On mobile, the wrapper is non-grid and the filter bar simply
          stacks at the top. When the Deal of the day banner is hidden
          (search/non-default-sort/no highlight), the wrapper picks up
          `is-no-featured` so the grid-template-areas collapse to 2 rows —
          avoids the empty `feat` row leaving extra vertical space. */}
      <div className={"desktop-layout" + (anyFeaturedShowing ? "" : " is-no-featured")}>
      <div className="de-filterbar">
        <div id="bar-search" >
          <TextField
            id="bar-search-field"
            type='search'
            onChange={deboucedOnChange}
            placeholder={t("Search_Default")}
            style={{ width: '100%' }}
            InputProps={{
              endAdornment: (
                <React.Fragment>
                  {search && search.length > 0 && (
                    <IconButton
                      type="button"
                      sx={{ p: '10px' }}
                      aria-label={t("Search_Clear", { defaultValue: i18n.language === 'fr' ? 'Effacer' : 'Clear' })}
                      onClick={handleClearSearch}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                    <SearchIcon />
                  </IconButton>
                </React.Fragment>
              ),
            }}

          />
        </div>
        <div className="de-filterbar-row">
          <Select
            id="select-sort"
            className={sort !== 3 ? 'is-active' : ''}
            style={{ width: '100%' }}
            value={sort}
            open={openSort}
            onOpen={() => { setOpenSort(true) }}
            onClose={() => { setOpenSort(false) }}
            onChange={handleChange}
            renderValue={(value) => {
              const sortMeta = {
                3: { Icon: WhatshotIcon, label: t("Filter_Order_New") },
                1: { Icon: AutoAwesomeIcon, label: t("Filter_Order_Best") },
                4: { Icon: LocalOfferIcon, label: t("Filter_Order_Discount") },
              };
              const m = sortMeta[value] || sortMeta[3];
              const Ic = m.Icon;
              return (
                <span className="filter-value">
                  <Ic className="filter-value-icon" fontSize="small" />
                  <span className="filter-value-label">{m.label}</span>
                </span>
              );
            }}
            MenuProps={MenuProps}
          >
            <MenuItem value={3}>
              <WhatshotIcon className="filter-menu-icon" fontSize="small" />
              {t("Filter_Order_New")}
            </MenuItem>
            <MenuItem value={1}>
              <AutoAwesomeIcon className="filter-menu-icon" fontSize="small" />
              {t("Filter_Order_Best")}
            </MenuItem>
            <MenuItem value={4}>
              <LocalOfferIcon className="filter-menu-icon" fontSize="small" />
              {t("Filter_Order_Discount")}
            </MenuItem>

          </Select>

          <FormControl id="multiple-checkbox-form">

            <Select
              labelId="multiple-checkbox-label"
              id="checkboxes-categories"
              className={(categories.length > 0 && selected.length < categories.length) ? 'is-active' : ''}
              multiple
              autoFocus
              value={selected}
              open={openCategorie}
              onOpen={() => { setOpenCategorie(true) }}
              onClose={() => { setOpenCategorie(false) }}
              displayEmpty
              onChange={(event) => {
                fetchSeqRef.current++;
                setNoResult(false);
                const value = event.target.value;
                setDeals([]);
                setHasMore(true);
                var selectedValue = [];
                if (value[value.length - 1] === "all") {
                  selectedValue = selected.length === categories.length ? [] : categories.map(x => x.id);
                  // Kick off the chained morph; clear it once the last card has settled.
                  setBulkAnim(true);
                  if (bulkAnimTimer.current) clearTimeout(bulkAnimTimer.current);
                  bulkAnimTimer.current = setTimeout(() => setBulkAnim(false), 40 * categories.length + 500);
                }
                else {
                  selectedValue = (typeof value === 'string' ? value.split(',') : value);
                }
                setSelected(selectedValue);
                gaEventTracker('categories', selected.toString());
                setTimer(false);
              }}
              input={<OutlinedInput />}
              renderValue={(value) => {
                const count = Array.isArray(value) ? value.length : 0;
                const total = categories.length;
                const filtered = total > 0 && count < total;
                return (
                  <span className="filter-value">
                    <GridViewIcon className="filter-value-icon" fontSize="small" />
                    <span className="filter-value-label">
                      {t("Filter_Category_Title")}
                      {filtered ? <span className="filter-count"> · {count}/{total}</span> : null}
                    </span>
                  </span>
                );
              }
              }
              MenuProps={{ ...MenuProps, MenuListProps: { className: bulkAnim ? 'bulk-animating' : undefined } }}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              <MenuItem
                value="all"
                className="selectAllCheckbox"
              >
                <ListItemIcon >
                  <Checkbox
                    checked={isAllSelected}
                    indeterminate={
                      selected.length > 0 && selected.length < categories.length
                    }
                  />
                </ListItemIcon>
                <ListItemText
                  className='selectAllButton'
                  primary={isAllSelected ? t("Filter_Category_Unselect_All") : t("Filter_Category_Select_All")}
                />
              </MenuItem>

              {categories.map((category, index) => (
                <MenuItem key={category.id} value={category.id} muiSkipListHighlight style={{ '--cat-index': index }}>
                  <Checkbox checked={selected.indexOf(category.id) > -1} />
                  <ListItemText className='selectCategories' primary={i18n.language === "fr" ? category.nameFr : category.nameEn} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
        {/* Flattened layout — at ≥1024px CSS grid places these in 2 cols;
            at 768-1023px they stack full-width (Deal of the day → Top
            Categories → Carousel → Deal list); on mobile DealOfTheDay +
            TopCategoriesSidebar hide themselves via CSS. */}
        {anyFeaturedShowing && (
          <div className="featured-stack">
            <DealOfTheDay deal={topDeal} />
          </div>
        )}
        <TopCategoriesSidebar
          categories={categories}
          selected={selected}
          onSelectOne={handleSidebarCategorySelect}
        />
        <div className="desktop-main">
          <FeaturedCarousel
            selected={selected}
            search={search}
            refreshKey={refreshKey}
            isHidden={heroHidden}
            excludeId={topDeal ? topDeal.id : null}
          />
          {(initialLoadShow || swapping) &&
            <Grid id="InitialLoad">
              <RotatingLines
                visible={true}
                height="72"
                width="72"
                strokeColor="#c8a795"
                strokeWidth="4"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </Grid>}
          {/* `sort` is intentionally NOT in the key: switching sort fetches the
              new page 1, preloads its images, then swaps the list in one shot
              (see reloadFirstPage). While that runs we hide the stale list and
              show the spinner above so no half-loaded images are ever visible.
              search/selected still remount (their reset flow relies on it). */}
          <div style={swapping ? { display: 'none' } : undefined}>
            <DealList deals={deals} key={search + "|" + selected} isLoading={isLoading} sortValue={sort} searchValue={search} selectedValue={selected || []} getDeals={getDeals} hasMore={hasMore} inListLoadShow={inListLoadShow} sx={{ visible: !inListLoadShow }} isRefScroller={isRefScroller} />
          </div>
        </div>
      </div>

      <ScrollToTopButton />
      <div className="feelLuck">
        {noResult && search.length === 0 &&
          <h1>{t("Filter_Category_Result_End_Title")}</h1>
        }
        {noResult && search.length > 0 &&
          <React.Fragment>
            <h1>{t("Search_Result_End_Title")}</h1>
            <span className='feelLuckyDescription'>{t("Search_Result_End_Subtext", { "0": search })}</span><br /><br />
            <Button
              className='button-color1'
              onClick={(e) => {
                if (isFacebookInAppBrowser) {
                  let dealId = 100;
                  if (deals.length > 1)
                    dealId = deals[deals.length - 1];
                  sessionStorage.setItem('dealId', dealId);
                  sessionStorage.setItem('selected', JSON.stringify(selected));
                  sessionStorage.setItem('sort', sort);
                  sessionStorage.setItem('search', search);
                }

                const url = 'https://www.amazon.ca/s?k=' + search + '&rh=p_85%3A5690392011%2Cp_n_deal_type%3A23565508011&dc&qid=1699653303&rnid=23565505011&tag=dealsempireca-20';
                gaEventTracker('feelLucky', search);
                window.open(url, '_blank');
                return false;
              }
            }
            >{t("Search_Result_End_Button")}</Button>
            <br />
          </React.Fragment>
        }
      </div>
      {(!isAppInstalled && !isFacebookInAppBrowser && (isAndroid || isIOS) && (isChrome || isSafari || isFirefox) && isVisible) && 
        <Slide direction="up" in={isVisible} >
          <div id="promptToInstall">
            <Grid container spacing={2} sx={{ width: '100%', margin: 'auto' }} >
              <Grid xs={7} className='verticalAlignCenter'><span>{t("Install_Title")}</span></Grid>
              <Grid xs={5} className='verticalAlignCenter'><button className='button-color1' onClick={promptToInstall}>{t("Install_Yes")}</button></Grid>
            </Grid>
          </div>
        </Slide>   
      }
    </div>
  );
}

export default App;
